import React from 'react'
import './index.scss'
import { ICONS } from '@Const/common'
import { NavLink } from 'react-router'
import clsx from 'clsx'

export interface DiagnosticCardStat {
    count?: number
    label?: string
    linkText: string
    linkUrl: string
}

interface DashboardDiagnosticCardProps {
    title: string
    isCollapsed: boolean
    setIsCollapsed(): void
    stats: DiagnosticCardStat[]
}

const DashboardDiagnosticCard = ({ title, isCollapsed, setIsCollapsed, stats }: DashboardDiagnosticCardProps) => (
    <div className={clsx('dashboard-content-card', 'diagnostic-card', isCollapsed && 'collapsed')}>
        <div className="diagnostic-card-header">
            <div className="diagnostic-card-title">
                <img className={clsx('error-icon', isCollapsed && 'collapsed')} src={ICONS.error} alt="" />
                <span className="diagnostic-card-title-text" title={title}>
                    {title}
                </span>
            </div>
            <div className="dropdown" onClick={() => setIsCollapsed()}>
                {isCollapsed ? (
                    <img src={ICONS.chevron_drop_up} alt="" />
                ) : (
                    <img src={ICONS.chevron_drop_down} alt="" />
                )}
            </div>
        </div>
        <div className="diagnostic-card-stats">
            {stats.map((stat, index) => (
                <div className="diagnostic-card-stat" key={stat.label ?? stat.linkText}>
                    {index > 0 && <div className="diagnostic-card-divider" />}
                    <div className="diagnostic-card-stat-content">
                        <div className="diagnostic-card-count">{stat.count && stat.count.toLocaleString('en-US')}</div>
                        {stat.label && <div className="diagnostic-card-label">{stat.label}</div>}
                        <NavLink className="diagnostic-card-link" to={stat.linkUrl}>
                            {stat.linkText}
                        </NavLink>
                    </div>
                </div>
            ))}
        </div>
    </div>
)

export default DashboardDiagnosticCard
